module.exports = __webpack_public_path__ + "img/systemselect.aac419dc.svg";